import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { retryScanJob } from '../api/receiptsApi';

// Failed → Queued bounce. Server re-uses the existing pending blob and
// broadcasts UpdateScanJobs, so the banner picks the new state up via the
// useActiveScanJobs subscription.
export default function useRetryScanJob() {
    return useMutation({
        mutationFn: (id) => retryScanJob(id),
        onError: (err) => toast.error(err?.message ?? 'Failed to retry scan'),
    });
}
